import { html } from "lit-html";

export const stationSelectorDivider = html`
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.727273" y="0.727273" width="30.5455" height="30.5455" rx="15.2727" fill="white" />
		<rect
			x="0.727273"
			y="0.727273"
			width="30.5455"
			height="30.5455"
			rx="15.2727"
			stroke="#C1C1C1"
			stroke-width="1.45455"
		/>
		<g clip-path="url(#clip0_8554_39571)">
			<path
				d="M11.9737 17.1874L10.7369 16L7.22809 19.3684L10.7369 22.7368L11.9737 21.5495L10.5877 20.2105H23.8948V18.5263H10.5877L11.9737 17.1874Z"
				fill="#C1C1C1"
			/>
			<path
				d="M20.0263 14.8126L21.2632 16L24.772 12.6316L21.2632 9.26315L20.0263 10.4505L21.4123 11.7895H8.10529V13.4737H21.4123L20.0263 14.8126Z"
				fill="#C1C1C1"
			/>
		</g>
		<defs>
			<clipPath id="clip0_8554_39571">
				<rect width="21.0526" height="20.2105" fill="white" transform="translate(5.47369 5.89474)" />
			</clipPath>
		</defs>
	</svg>
`;

export const stationSelectorChevron = html`
	<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M13.5 1.5625L7.53125 7.28125C7.34375 7.4375 7.15625 7.5 7 7.5C6.8125 7.5 6.625 7.4375 6.46875 7.3125L0.46875 1.5625C0.15625 1.28125 0.15625 0.78125 0.4375 0.5C0.71875 0.1875 1.21875 0.1875 1.5 0.46875L7 5.71875L12.4688 0.46875C12.75 0.1875 13.25 0.1875 13.5312 0.5C13.8125 0.78125 13.8125 1.28125 13.5 1.5625Z"
			fill="#C1C1C1"
		/>
	</svg>
`;

export const stationSelectorCountryArrowDesktop = html`
	<svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2.34766 0.9375L8.78125 7.65234C8.92188 7.82812 9.02734 8.03906 9.02734 8.25C9.02734 8.46094 8.92188 8.67188 8.78125 8.8125L2.34766 15.5273C2.03125 15.8789 1.46875 15.8789 1.15234 15.5625C0.800781 15.2461 0.800781 14.7188 1.11719 14.3672L7.02344 8.21484L1.11719 2.09766C0.800781 1.78125 0.800781 1.21875 1.15234 0.902344C1.46875 0.585938 2.03125 0.585938 2.34766 0.9375Z"
			fill="currentColor"
		/>
	</svg>
`;

export const stationSelectorCountryArrowMobile = html`
	<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.00077 5.5H0L2.49962 3L5.00077 0.5L7.50039 3L10 5.5L5.00077 5.5Z" fill="#1B365D" />
	</svg>
`;
